import styled from "styled-components";

import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import StartOver from ".";

const DynamicPadding = styled("div")`
  padding: ${({ $isWideView }) => ($isWideView ? "0 10px" : "0")};
`;

const ContainedCompactStartOver = () => {
  const { isWideView } = useTwoFAContext();

  return (
    <DynamicPadding $isWideView={isWideView}>
      <StartOver compact />
    </DynamicPadding>
  );
};

export default ContainedCompactStartOver;
